<div class="card__photo" [ngStyle]="{ 'aspect-ratio': aspectRatio }">
  @if (src) {
    <app-image class="card__photo-image" [src]="src" [placeholder]="placeholder ?? true" [alt]="alt" [fill]="true" [priority]="priority" [object-position]="position" [ngStyle]="{ 'aspect-ratio': aspectRatio }"></app-image>
  }
</div>
